<template>
  <div class="Leaderboard">
    <div class="container container--wide">
      <Table
        :url="getLeaderboardUrl"
        :sort="sort.by"
        :order="sort.order"
      >
        <template v-slot:default="response">
          <Row header>
            <Cell>Rank</Cell>
            <Cell sort="name"   v-model="sort" class="text-left">Player</Cell>
            <Cell sort="wins"   v-model="sort">Wins</Cell>
            <Cell sort="losses" v-model="sort">Losses</Cell>
            <Cell sort="played" v-model="sort">Played</Cell>
            <Cell sort="rating" v-model="sort">Rating</Cell>
          </Row>

          <template v-for="(player, index) in response">
            <Row
              :to="decodeURI (
                resolve ({
                  name: 'playerProfile',
                  params: {
                    name: player.name
                  }
                })
              )"
            >
              <Cell class="Players-rank">
                <img
                  :src="'/assets/icons/leagues/' + league (player.rank) + '.png'"
                  v-tooltip="league (player.rank)"
                />

                {{ ordinal (player.rank) }}
              </Cell>

              <Cell class="text-left">
                <span class="W3S-table__icon">
                  <Clan></Clan>
                  <BattleTag :tag="player.name"></BattleTag>
                </span>
              </Cell>

              <Cell class="green" v-if="player.wins !== null">
                {{ player.wins }}

                <Bar  width="100px"
                     :fill="relative ('wins', player, response)"></Bar>
              </Cell> <Cell v-else></Cell>

              <Cell class="red" v-if="player.losses !== null">
                {{ player.losses }}

                <Bar  width="100px"
                     :fill="relative ('losses', player, response)"
                     :invert="true"></Bar>
              </Cell> <Cell v-else></Cell>

              <Cell class="orange" v-if="player.played">
                {{ player.played }}

                <Bar  width="100px"
                     :fill="relative ('played', player, response)"></Bar>
              </Cell> <Cell v-else></Cell>

              <Cell v-if="player.rating">
                {{ Math.round (player.rating) }}

                <Delta :x="player.lastChange"></Delta>

                <Bar  width="100px"
                     :fill="relative ('rating', player, response)"></Bar>
              </Cell> <Cell v-else></Cell>

              <!-- <td v-if="player.rating" :class="{
                'green' : player.lastChange > 0,
                'grey'  : player.lastChange == 0,
                'red'   : player.lastChange < 0
              }>
                {{ Math.abs (player.lastChange) }}

                <i class="fas fa-angle-up" v-if="player.lastChange > 0"></i>
                <strong v-if="player.lastChange == 0">-</strong>
                <i class="fas fa-angle-down" v-if="player.lastChange < 0"></i>
              </td> <td v-else></td> -->
            </Row>
          </template>

          <!-- <div class="Entry-Header">
            {{ league }}
          </div>
          <div class="Entry-Body">

          </div>

          <div class="Entry-Header">
            {{ league }}
          </div> -->
        </template>
      </Table>
    </div>
  </div>
</template>

<script>
  import config from '@/config';
  import { resolve } from '@/legacy/lib/routerUtils';
  import { httpBuildQuery, ordinal, isTransition, relative, league } from '@/legacy/lib/util';
  import { metaFactory } from '@/legacy/lib/template';
  import Clan from '@/legacy/components/widgets/Clan';
  import Bar from '@/legacy/components/widgets/Bar';
  import BattleTag from '@/legacy/components/widgets/BattleTag';
  import Loader from '@/legacy/components/widgets/Loader';
  import Delta from '@/legacy/components/widgets/Delta';
  import Key from '@/legacy/lib//model/Key';
  import { Table, Row, Cell }  from '@/legacy/components/widgets/Table';

  export default {
    metaInfo () {
      return metaFactory ({
        title: `${this.pk.map} Leaderboard`,
        description: `Browse the ratings of who have battled for victory in Warcraft III's ${this.map} custom map.`,
        noindex: true
      });
    },

    props: {
      pk: {
        type: Object,
        default: () => new Key ()
      }
    },

    methods: {
      ordinal,
      relative,
      resolve,
      league
    },

    data () {
      return {
        leaderboard: {},
        sort: {
          by: 'rank',
          order: 'asc'
        }
      }
    },

    components: {
      Bar,
      Clan,
      Loader,
      Table,
      Row,
      Cell,
      Delta,
      BattleTag
    },

    computed: {
      getLeaderboardUrl () {
        return httpBuildQuery (
          '/leaderboard',
          this.pk
        );
      }
    }
  };
</script>

<style lang="scss">
  $leaderboard-header-min-height: 120px;

  .Leaderboard {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }

  .Players {
    .Entry {
      &-Header {
        td {
          border-left: none;
          border-right: none;
          border-top: none;
          padding: 0;
        }
      }
    }

    &-rank {
      img {
        width: 45px;
        height: 45px;
        margin-right: 5px;
      }
    }
  }

  .Entry {
    flex: 1 0 30%;
    margin: 8px;

    &-Content {
      background-color: shade($w3s-white, 2);
      border: $w3s-border-region;

      box-shadow:
        4px 5px 8px 3px shade($w3s-black, 40);

      .W3S-league {
        height: 125px;
        width: 125px;
      }
    }

    &-Header {
      background-size: cover;
      background-repeat: no-repeat;
      margin: 0;
      position: relative;
      text-align: center;
      min-height: $leaderboard-header-min-height;
      line-height: $leaderboard-header-min-height;
      font-size: 38px;
      text-transform: capitalize;

      td {
        height: $leaderboard-header-min-height;
      }
    }

    &-Body {
      border-top: $w3s-border-region;
      background-color: shade($w3s-white, 6);
      padding: 12px;
    }

    &-Title {
      margin: 0 0 20px -40px;
      font-size: 24px;
      text-align: center;
    }

    &-Wins,
    &-Losses,
    &-Rating,
    &-WinRate {
      font-size: 18px;
      margin-bottom: 8px;
      display: flex;
      flex-direction: row;
      position: relative;
    }

    &-Label:first-child {
      min-width: 80px;
    }

    &-Label {
      min-width: 60px;
      margin: 0 8px;

      &:first-child {
        text-align: right;
      }

      &:last-child {
        text-align: left;
      }
    }

    // &-BG-grandmaster {
    //   // background-image: asset('background/GM.png');
    //   // background-position: 0 -40px;
    // }

    // &-BG-master {
    //   // background-image: url('https://i.ytimg.com/vi/kxwE8c_9wOk/maxresdefault.jpg');
    //   // background-position: 0 -40px;
    // }

    // &-BG-diamond {
    //   background-image: url('https://vignette.wikia.nocookie.net/wowwiki/images/5/5c/EasternPlaguelandsScenery.jpg/revision/latest?cb=20080301123448');
    //   background-position: 0 -40px;
    // }

    // &-BG-platinum {
    //   background-image: url('https://vignette.wikia.nocookie.net/wowwiki/images/c/cd/Circle_of_Outer_Binding.jpg/revision/latest?cb=20061106110224');
    //   background-position: 0 -40px;
    // }

    // &-BG-gold {
    //   background-image: url('https://wow.zamimg.com/uploads/screenshots/normal/175174-loch-modan.jpg');
    //   background-position: 0 -40px;
    // }

    // &-BG-silver {
    //   background-image: url('https://i.ytimg.com/vi/IwlPgQtGguw/maxresdefault.jpg');
    //   background-position: 0 -40px;
    // }

    // &-BG-bronze {
    //   background-image: url('https://vignette.wikia.nocookie.net/wowwiki/images/a/aa/Elwynn_Forest.jpg/revision/latest?cb=20130509185507');
    //   background-position: 0 -40px;
    // }
  }
</style>